import {Map} from "@iminside/react-yandex-maps";
import {YandexMapProps} from "../model/types";

export const YandexMap = (props: YandexMapProps) => {
    return (
        <Map {...props} />
    );
};
